module.exports = __webpack_public_path__ + "img/tonelada.10af8507.png";